<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 grid-margin">
                            <div class="card">
                                <items-list/>
                            </div>
                        </div>    
                    </div> 
                    <div class="row">
                        <div class="col-6 grid-margin">
                            <div class="card">
                                <cart />
                            </div>
                        </div>    
                        <div class="col-6 grid-margin">
                            <div class="card">
                                <customer-info-form />
                            </div>
                        </div> 
                    </div> 
                    <div class="row">
                        <div class="col-9 grid-margin">
                            <div class="card">
                            
                            </div>
                        </div>
                        <div class="col-3 grid-margin">
                            <b-button variant="success" 
                                class="mr-2"
                                v-on:click="handleBtnCreateOrder">
                                Create Order
                            </b-button>
                            <b-button variant="light" 
                                    v-on:click="handleBtnCancel">
                                Cancel
                            </b-button>
                        </div>
                    
                    </div> 
                </div> 
            </div>
        </div>
    </div>
</template>

<script lang="js">
import { mapState, mapGetters } from'vuex'
import Cart from './Cart.vue'
import ItemsList from './ItemsList.vue'
import CustomerInfoForm from './CustomerInfoForm.vue'
import TimeFormatter from '../../../src/assets/js/TimeFormatter'
export default{
    name: 'orderbyphoneaddfrom',
    components: {
        Cart,
        ItemsList,
        CustomerInfoForm
    },
    data () {
        return {
            restaurantName : ''
        }
    },
    computed: {
        ...mapState({
            items: state => state.ordersbyphonecontrol.currentMenu.menuItems,
            categories: state => state.ordersbyphonecontrol.currentMenu.menuCategories,
            isPhoneValid: state => state.ordersbyphonecontrol.isPhoneValid,
            phoneNumber: state => state.ordersbyphonecontrol.cart.phoneNumber
            
        }),
        ...mapGetters({
            itemsByCategory : 'ordersbyphonecontrol/getItemsByCategory',
        }),
        
    },
    methods: {
        async handleBtnCreateOrder () {

            if (this.$store.state.ordersbyphonecontrol.cart.selectedItems.length > 0) {
                //Set loading
                this.$store.commit('loading/setLoadingState', true);
                let order = {
                    restaurantId : this.$store.state.ordersbyphonecontrol.restaurantId,
                    pickupNumber : this.$store.state.ordersbyphonecontrol.cart.pickupNumber,
                    amount : this.$store.state.ordersbyphonecontrol.cart.totalPrice,
                    comment : this.$store.state.ordersbyphonecontrol.cart.comment,
                    customerName : this.$store.state.ordersbyphonecontrol.cart.customerName,
                    phoneNumber : this.$store.state.ordersbyphonecontrol.cart.phoneNumber,
                    pickupTime : TimeFormatter.timeToString(this.$store.state.ordersbyphonecontrol.cart.pickupTime),
                    waitingTime : this.$store.state.ordersbyphonecontrol.cart.waitingTime,
                    cart : this.$store.state.ordersbyphonecontrol.cart.selectedItems
                }

                if (!this.isPhoneValid) {
                    this.$store.commit('ordersbyphonecontrol/updatePhoneNumberState', '');
                    order.phoneNumber = '';
                    await this.$store.dispatch('ordersbyphonecontrol/createOrderByPhoneWithOrderManagerAction', { order });
                }

                else {
                    await this.$store.dispatch('ordersbyphonecontrol/createOrderByPhoneWithOrderManagerAction', { order });
                }
                
                this.$store.commit('ordersbyphonecontrol/clearCartState');
                this.$store.commit('loading/setLoadingState', false);
                this.$router.push('/ordermessages');
            }
            
        },
        handleBtnCancel() {
            this.$store.commit('ordersbyphonecontrol/clearCartState');
            this.$router.push('/ordermessages');
        },
        handleBtnAddToCart (item) {
            this.$store.commit('ordersbyphonecontrol/addItemToCartState', item);
        },
        itemShortName( name ) {
            let itemName = name.toString();
            let index = itemName.indexOf('.');
            if (index > 0) {
                return itemName.slice(0, index+1);
            }
            return name;
            
        }
    },
    async created() {
        let id = this.$route.params.id;
        let restaurant = this.$store.getters['restaurants/getRestaurantById'](id);

        this.$store.commit('ordersbyphonecontrol/setRestaurantIdState', id);
        this.$store.commit('ordersbyphonecontrol/setRestaurantNameState', restaurant.restaurantName);
        
        await this.$store.dispatch('ordersbyphonecontrol/getMenusAction', id);
        await this.$store.dispatch('ordersbyphonecontrol/getPickupNumberAction', id);

    }
}
</script>


<style lang="scss">
   .button-item {
       padding: 15px 32px;
       margin-bottom: 1%;
       font-size:20px;
   }
</style>